import { useTranslation } from 'react-i18next';
import type { FlexProps } from '@chakra-ui/react';

import type { ApiNabanDeedDetails } from '@izimi/api';

import { NabanDetailsListCard } from '../../components/NabanDetailsListCard';
import { NabanDetailsListItem } from '../../components/NabanDetailsListItem';
import { useNabanDeedDetailsItems } from '../../hooks/useNabanDeedDetailsItems';

type Props = {
  deedDetails: ApiNabanDeedDetails;
};

export const NabanDeedDetailsCard = ({ deedDetails, ...props }: Props & FlexProps) => {
  const { t } = useTranslation('naban');

  const deedDetailsItems = useNabanDeedDetailsItems({ deedDetails });

  return (
    <NabanDetailsListCard title={t('deed.details.title')} minWidth={0} width='100%' {...props}>
      {deedDetailsItems.map((props) => (
        <NabanDetailsListItem key={props.title} {...props} />
      ))}
    </NabanDetailsListCard>
  );
};
